import { Component, ChangeDetectorRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ActionSheetController, App, Config, NavController, NavParams } from 'ionic-angular';
import { TextDataProtectPage } from '../../../../pages/textPages/text-data-protect/text-data-protect';
import { CategoriesProvider, CategoryModel } from '../../../../providers/categories/categories';
import { LoaderProvider } from '../../../../providers/loader/loader';
import { LanguageModel, SettingsProvider } from '../../../../providers/settings/settings';
import { MyPicsListModel, PrivateProfile, UserProvider } from '../../../../providers/user/user';
import { BackgroundModel, SinleValueModel, TextValueModel, ValueProvider } from '../../../../providers/value/value';
import { TextBuildingServicesPage } from '../../../textPages/text-building-services/text-building-services';
import { TextCookiesPage } from '../../../textPages/text-cookies/text-cookies';
import { TextImpressPage } from '../../../textPages/text-impress/text-impress';
import { PrivateProfilePage } from '../private-profile/private-profile';
import { SessionProvider } from '../../../../providers/session/session';
import { LoginPage } from '../../../login/login/login';
import { Subscription } from 'rxjs';
import { DarkMode, ThemeMode } from '../../../../providers/dark-mode/dark-mode';
import { debounceTime } from 'rxjs/operators'
import { AdsProvider } from '../../../../providers/ads/ads';
import { AppDetectorProvider } from '../../../../providers/detector/detector';

/**
 * Generated class for the SettingsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-settings',
  templateUrl: 'settings.html'
})
export class SettingsPage {
  languages: LanguageModel[] = [];
  selectedLanguage: string;
  toDarkSub:Subscription;
  isDark:boolean;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public app: App,
    public translate: TranslateService,
    public userService: UserProvider,
    public loadingCtrl: LoaderProvider,
    public config: Config,
    private valueService: ValueProvider,
    private actionCtrl: ActionSheetController,
    private categoryService: CategoriesProvider,
    private settingsService: SettingsProvider,
    private sessionService: SessionProvider,
    private ref: ChangeDetectorRef,
    private darkModeService: DarkMode,
    private ads:AdsProvider,
    private appDetector:AppDetectorProvider
  ) {
    this.languages = navParams.data.data.languages;
    this.selectedLanguage = navParams.data.data.selectedLanguage;
  }

  changeLanguage() {
    this.settingsService.setLanguage(this.selectedLanguage);
    this.ref.detectChanges();
    this.ref.markForCheck();
  }

  ngOnInit(){
    this.toDarkSub = this.darkModeService.themeModeSubject.subscribe((mode: ThemeMode) => {
      this.isDark = (mode === ThemeMode.DarkMode);
    });
  }
  runDarkMode(){
    this.isDark = !this.isDark;
    const mode = this.isDark ? ThemeMode.DarkMode : ThemeMode.LightMode;
    this.darkModeService.setThemeMode(mode);
    localStorage.setItem('darkMode', JSON.stringify(mode));
    if(this.appDetector.isEventsApp()){
      let body = <HTMLElement>document.querySelector('body');
      if (this.isDark && !body.classList.contains(ThemeMode.DarkMode)) {
        body.classList.add(ThemeMode.DarkMode);
      } else if (!this.isDark && body.classList.contains(ThemeMode.DarkMode)) {
        body.classList.remove(ThemeMode.DarkMode);
      }
    }
      this.ads.updateAdMobBannerBackground();
  }

  ionViewWillLeave() {
    // this.translate.get('GLOBAL_BACK').subscribe(backLabel => {
    //   this.config.set('ios', 'backButtonText', backLabel);
    // });

    // TODO
    // var elems = document.querySelectorAll(".back-button-text-ios");
    // elems.forEach(function(element) {
    //   element.innerHTML = backLabel;
    // });
  }

  public isLoged(): boolean {
    return this.sessionService.isLoged;
  }

  openProfile() {
    var loader = this.loadingCtrl.create({ content: this.translate.instant('GLOBAL_LOADING') });
    loader.present();
    // @ts-ignore
    Promise.all<SinleValueModel[], SinleValueModel[], TextValueModel[], CategoryModel[], MyPicsListModel[], BackgroundModel[], PrivateProfile>([
      this.valueService.getProfileTitles(),
      this.valueService.getProfileTypes(),
      this.valueService.getCountries(),
      this.categoryService.getProfileCategoires(),
      this.userService.getMyPhotos(),
      this.valueService.getProfileBackgrounds(),
      this.userService.getPrivateProfile()
    ]).then(values => {
      (this.app.getRootNav() as NavController)
        .push(PrivateProfilePage, {
          data: {
            titles: values[0],
            types: values[1],
            countries: values[2],
            categories: values[3],
            photos: values[4],
            backgrounds: values[5],
            profile: values[6]
          }
        })
        .then(() => loader.dismiss());
    });
  }

  deleteProfile() {
    this.actionCtrl.create({
      title: this.translate.instant('PROFILE_DELETE_CONFIRM_MESSAGE'),
      buttons: [
        {
          text: this.translate.instant('GLOBAL_YES'),
          handler: () => {
            this.userService.removeAccount().then(() => {
              this.userService.logout().then(() => {
                (this.app.getRootNav() as NavController).popToRoot().then(() => {
                  (this.app.getRootNav() as NavController).push(LoginPage);
                });
              });
            });
          }
        },
        {
          text: this.translate.instant('GLOBAL_NO')
        }
      ]
    }).present();
  }

  showAGBSPage() {
    (this.app.getRootNav() as NavController).push(TextBuildingServicesPage);
  }

  showDataPage() {
    (this.app.getRootNav() as NavController).push(TextDataProtectPage);
  }

  showImpressPage() {
    (this.app.getRootNav() as NavController).push(TextImpressPage);
  }

  showCookiesPage() {
    (this.app.getRootNav() as NavController).push(TextCookiesPage);
  }

  logout() {
    let loader = this.loadingCtrl.create({ content: this.translate.instant('GLOBAL_LOADING') });
    loader.present();
    this.userService.logout().then(succ => {
      if (succ) {
        (this.app.getRootNav() as NavController).popToRoot();
      }
      loader.dismiss();
    });
  }

  ngOnDestroy() {
    if (this.toDarkSub) {
      this.toDarkSub.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// /src/pages/me/settings/settings/settings.ts